import script from "./AcLottiePreloader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AcLottiePreloader.vue?vue&type=script&setup=true&lang=ts"

import "./AcLottiePreloader.vue?vue&type=style&index=0&id=2cb209bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb209bc"]])

export default __exports__